import React, {useEffect, useState, useCallback} from 'react'

export const AdBanner = React.memo(({ appData:{customerdata}, appData:{storedata} }) => {
	
	const adBannerData = customerdata?.filter(data => data.contentType === "SchoolStorePromotion")[0]

	const hasYearbook = storedata?.schoolStoreAdBannerData?.hasYearbookCatalog && adBannerData.yearbook
	const hasRegalia = storedata?.schoolStoreAdBannerData?.hasRegalia && adBannerData.regalia
	const hasJackets = storedata?.productCatalogs?.filter(cat => cat.catalogOsr.toUpperCase() === 'HS_JACKETS').length
	const hasJewelry = storedata?.productCatalogs?.filter(cat => cat.catalogOsr.toUpperCase() === 'SHOP_CLASS_RING_CUSTOMER_CATALOG').length

	/* const unicodToHexToEmoji = useCallback(
		(text) => {
			console.log(text);
			const res = text.replace(/\\u([0-9A-F]{4})/ig, (_, g) => String.fromCharCode(`0x${g}`))
			console.log(res);
			return res
		}, [],
	) */

	const content = useCallback(
		() => {
			if (hasJewelry || hasJackets || hasYearbook) 
				if (hasJackets && !hasJewelry) return <div className="promotion" style={{marginBottom: '2px'}}><div className='container'/><p>🎁 Holiday Shipping | Order Your School <a class="c-link" href="https://www.jostens.com/apps/jcom/router.mvc?code=JKT" rel="noopener noreferrer" data-stringify-link="https://www.jostens.com/apps/jcom/router.mvc?code=JKT" data-sk="tooltip_parent">Jacket</a> by November 5 🎁</p></div>
				if (!hasJackets && hasJewelry) return <div className="promotion" style={{marginBottom: '2px'}}><div className='container'><p>🎁 Holiday Shipping | Order Your School <a class="c-link" href="https://www.jostens.com/apps/jcom/router.mvc?code=RINGS" rel="noopener noreferrer" data-stringify-link="https://www.jostens.com/apps/jcom/router.mvc?code=RINGS" data-sk="tooltip_parent">Jewelry</a> by November 5 🎁</p></div></div>
				if (hasJackets && hasJewelry) return <div className="promotion" style={{marginBottom: '2px'}}><div className='container'><p>🎁 Holiday Shipping | Order Your School <a class="c-link" href="https://www.jostens.com/apps/jcom/router.mvc?code=JKT" rel="noopener noreferrer" data-stringify-link="https://www.jostens.com/apps/jcom/router.mvc?code=JKT" data-sk="tooltip_parent">Jacket</a> and <a class="c-link" href="https://www.jostens.com/apps/jcom/router.mvc?code=RINGS" rel="noopener noreferrer" data-stringify-link="https://www.jostens.com/apps/jcom/router.mvc?code=RINGS" data-sk="tooltip_parent">Jewelry</a> by November 5 🎁</p></div></div>
				if (hasYearbook) return <div className="promotion" style={{marginBottom: '2px'}}><div className='container' dangerouslySetInnerHTML={{__html: adBannerData.yearbook}} /></div>
			else if (hasRegalia) return <div className="promotion" style={{marginBottom: '2px'}}><div className='container' dangerouslySetInnerHTML={{__html: adBannerData.regalia}} /></div>
			else return <div className="promotion" style={{marginBottom: '2px'}}><div className='container' dangerouslySetInnerHTML={{__html: adBannerData.paymentPlan}} /></div>
		},
		[customerdata, storedata],
	)
	
	/* const Alert = ({ alert, i }) => {
		
		// const [[days, hrs, mins], setTime] = useState([0, 0, 0]);
		// const [showCounter, setShowCounter] = useState(alert.endDate && alert.catalogOsr === 'HS_JACKETS')

		
		const tick = () => {
			const today = new Date()
			const eventDay = new Date(alert.endDate)
			const diff = eventDay - today
			const diffDays = Math.floor(diff / 86400000); // days
			const diffHours = Math.floor((diff % 86400000) / 3600000); // hours
			const diffMinutes = Math.round(((diff % 86400000) % 3600000) / 60000); // minutes
			setTime([diffDays, diffHours, diffMinutes])
		};	
		
		useEffect(() => {
			let timerId
			if (showCounter) {
				tick()
				timerId = setInterval(() => tick(), 60000)
				const alertEl = document.querySelector(`.container.alert${i}`)
				if (alertEl) {
					const newHtml = alert.html.split(' | ')
					newHtml.splice(3, 0, `Days: <span style={${counterStyle}}>${days}</span> Hours: <span style={${counterStyle}}>${hrs}</span> Minutes: <span style={${counterStyle}}>${mins}</span>`)
					alertEl.innerHTML = newHtml.join(' | ')
				}
			}
			return () => timerId && clearInterval(timerId)
		}, [days, hrs, mins])
 
		return <div className="promotion" style={{marginBottom: '2px'}}>
				<div className={'container' + ` alert${i}`} dangerouslySetInnerHTML={{__html: alert.html}}></div>
			</div>
	} */
		
	return 	content()
})

// export default React.memo(AdBanner)